import { api } from './api';

export interface Company {
  id: string;
  name: string;
  countryCode: string;
  fiscalYearStartMonth: number;
  reportingCurrency: string;
  primaryLocale: string;
  plan: 'free' | 'growth' | 'global' | 'enterprise';
  seatLimit: number;
  verificationStatus: 'pending' | 'verified' | 'pending_review' | 'rejected';
  aiModelDefault: string;
  aiReasoningModel: string;
  aiEmbeddingModel: string;
  aiMonthlyCapCents: number | null;
  deploymentKind: 'cloud' | 'onprem';
  industry: string | null;
  createdAt: string;
}

export interface CreateCompanyDto {
  name: string;
  countryCode: string;
  fiscalYearStartMonth: number;
  reportingCurrency: string;
  primaryLocale: string;
  industry?: string | null;
  deploymentKind?: 'cloud' | 'onprem';
  companyUrl?: string | null;
}

export interface UpdateCompanySettingsDto {
  aiMonthlyCapCents?: number | null;
  aiModelDefault?: string;
  aiReasoningModel?: string;
  aiEmbeddingModel?: string;
}

export const companiesApi = {
  async list(): Promise<Company[]> {
    const r = await api.get<Company[]>('/api/companies');
    return r.data;
  },
  async create(dto: CreateCompanyDto): Promise<{ company: Company; verificationReason: string; defaultWorkspaceId: string }> {
    const r = await api.post<{ company: Company; verificationReason: string; defaultWorkspaceId: string }>('/api/companies', dto);
    return r.data;
  },
  async updateSettings(id: string, dto: UpdateCompanySettingsDto): Promise<Company> {
    const r = await api.patch<Company>(`/api/companies/${id}/settings`, dto);
    return r.data;
  },
};

/** Default fiscal year start month by country. JP/IN/UK = April. */
export function defaultFiscalStartMonthForCountry(country: string | null | undefined): number {
  if (!country) return 1;
  const c = country.toUpperCase();
  if (c === 'JP') return 4;
  if (c === 'IN') return 4;
  if (c === 'UK' || c === 'GB') return 4;
  return 1;
}
